export enum CashDistributionViewType {
    DistributionCountAverage = 0,
    DistributionCountTotal = 1,
}
